import React, { useState, useEffect } from 'react';
import { createWhatsappQRCode, checkWhatsappQRCodeStatus } from '../../../services/apiService';
import { oneKlicks } from '../../../SDK/oneclick';
import { getuserdata } from '../../../services/apiService';

const WhatsappConfig = () => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [qrCode, setQrCode] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);
    const [sessionId, setSessionId] = useState("");
    const [qrCodeStatus, setQrCodeStatus] = useState(null);
    const [showNewDeviceForm, setShowNewDeviceForm] = useState(false);
    const [connectedDevices, setConnectedDevices] = useState([
    ]);

    useEffect(() => {
        getConnectedDevices();
    }, []);

    const getConnectedDevices = async () => {
        try {
            const tableSchema = "";
            const tableName = "whatsapp_sessions";
            const conditions = {};
            const orderBy = "id ASC";
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("response getConnectedDevices :", response);
            if (response.success && response.data.length > 0) {
                setConnectedDevices(response.data);
            } else {
                setConnectedDevices([]);
            }
        } catch (error) {
            console.error('Error getting connected devices:', error);
            setConnectedDevices([]);
        }
    };

    const generateQRCode = async () => {
        if (!phoneNumber.trim()) {
            alert('Please enter a valid phone number');
            return;
        }

        setIsGenerating(true);
        try {
            // Format phone number for session ID: remove + and format as session_919705656070
            const cleanPhoneNumber = phoneNumber.replace(/[^\d]/g, ''); // Remove all non-digits
            const sessionId = `session_${cleanPhoneNumber}`;

            console.log('Original phone number:', phoneNumber);
            console.log('Clean phone number:', cleanPhoneNumber);
            console.log('Session ID:', sessionId);

            const response = await createWhatsappQRCode(sessionId);
            console.log("response generateQRCode :", response);

            //WhatsApp QR code response: {success: true, message: 'QR code generated successfully', qrCode: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARQA…8rLXWJQ9rrXXJw1prXfL/ATLpeH68nm4hAAAAAElFTkSuQmCC', sessionId: 'session_919705656070', status: 'waiting_for_scan'}
            // response generateQRCode : {success: true, message: 'QR code generated successfully', qrCode: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARQA…8rLXWJQ9rrXXJw1prXfL/ATLpeH68nm4hAAAAAElFTkSuQmCC', sessionId: 'session_919705656070', status: 'waiting_for_scan'}

            if (response && response.success) {
                setQrCode(response.qrCode);
                setSessionId(response.sessionId);
                setQrCodeStatus(response.status);
                const newDevice = {
                    id: Date.now(), // Simple ID generation
                    phoneNumber: phoneNumber,
                    deviceName: `Device ${phoneNumber}`,
                    status: 'waiting_for_scan',
                    lastConnected: new Date().toLocaleString(),
                    qrCode: response.qrCode
                };
                setConnectedDevices(prev => [...prev, newDevice]);
                const data = {
                    phoneNumber: phoneNumber,
                    userId: await getuserdata('id'),
                    sessionId: response.sessionId,
                    deviceName: `Device ${phoneNumber}`,
                    status: response.status,
                    lastConnected: new Date().toLocaleString(),
                    qrCode: response.qrCode,
                    sessionId: response.sessionId
                };
                const tableSchema = "";
                const tableName = "whatsapp_sessions";
                const conditions = { sessionId: response.sessionId };
                const createResponse = await oneKlicks.create(tableSchema, tableName, data, conditions);
                console.log("response create whatsapp_sessions :", createResponse);
                if (createResponse.success) {
                    getConnectedDevices();
                    console.log('QR Code generated successfully. Status:', response.status);
                    console.log('Session ID:', response.sessionId);
                } else {
                    alert("Error creating whatsapp_sessions :", createResponse.message);
                }
            } else {
                const errorMsg = response?.message || 'Invalid response from server';
                alert(`Error: ${errorMsg}`);
            }
        } catch (error) {
            console.error('Error generating QR code:', error);
            alert(`Error generating QR code: ${error.message}`);
        } finally {
            setIsGenerating(false);
        }
    };
    useEffect(() => {
        // check QR code status every 1 seconds
        if (sessionId && sessionId !== "") {
            const interval = setInterval(() => {
                checkQRCodeStatus();
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [sessionId]);

    const checkQRCodeStatus = async () => {
        try {
            const response = await checkWhatsappQRCodeStatus(sessionId);
            console.log("response checkQRCodeStatus :", response);

            if (response && response.success) {
                setQrCodeStatus(response.status);

                if (response.status === "connected") {
                    alert("WhatsApp connected successfully! 🎉");
                    setQrCodeStatus("connected");

                    // Update the database record status
                    try {
                        const tableSchema = "";
                        const tableName = "whatsapp_sessions";
                        const conditions = { sessionId: sessionId };
                        const updateData = {
                            status: 'connected',
                            lastConnected: new Date().toLocaleString()
                        };

                        const updateResponse = await oneKlicks.update(tableSchema, tableName, updateData, conditions);
                        console.log("response update whatsapp_sessions status :", updateResponse);

                        if (updateResponse.success) {
                            // Refresh the connected devices list
                            getConnectedDevices();
                            console.log('WhatsApp session status updated to connected');
                        } else {
                            console.error("Error updating whatsapp_sessions status:", updateResponse.message);
                        }
                    } catch (dbError) {
                        console.error('Error updating database status:', dbError);
                    }

                    // Reset form and hide it
                    setShowNewDeviceForm(false);
                    setPhoneNumber('');
                    setQrCode(null);
                    setSessionId("");
                    setQrCodeStatus(null);
                }
            }
        } catch (error) {
            console.error('Error checking QR code status:', error);
            // Don't show alert for every error, just log it
            // The user will see the QR code is still there
        }
    };

    const handleAddNewDevice = () => {
        setShowNewDeviceForm(true);
        setPhoneNumber('');
        setQrCode(null);
        setSessionId("");
        setQrCodeStatus(null);
    };

    const handleCancelNewDevice = () => {
        setShowNewDeviceForm(false);
        setPhoneNumber('');
        setQrCode(null);
        setSessionId("");
        setQrCodeStatus(null);
    };

    const handleDisconnectDevice = (deviceId) => {
        setConnectedDevices(prev => prev.filter(device => device.id !== deviceId));
        alert('Device disconnected successfully');
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case 'connected':
                return '🟢';
            case 'disconnected':
                return '🔴';
            case 'waiting_for_scan':
                return '🟡';
            default:
                return '⚪';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'connected':
                return 'Connected';
            case 'disconnected':
                return 'Disconnected';
            case 'waiting_for_scan':
                return 'Waiting for Scan';
            default:
                return 'Unknown';
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-yourdetails dc-tabsinfo" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="dc-tabscontenttitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3>WhatsApp Connected Devices</h3>
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddNewDevice}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                        >
                            <span>+</span> Add New Device
                        </button>
                    </div>

                    {/* Connected Devices List */}
                    <div className="connected-devices-list">
                        {connectedDevices.length > 0 ? (
                            <div className="devices-grid">
                                {connectedDevices.map((device) => (
                                    <div key={device.id} className="device-card" style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="device-header">
                                            <div className="device-info">
                                                <h5>{device.deviceName}</h5>
                                                <p className="phone-number">{device.phoneNumber}</p>
                                            </div>
                                            <div className="device-status">
                                                <span className={`status-badge ${device.status}`}>
                                                    {getStatusIcon(device.status)} {getStatusText(device.status)}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="device-details">
                                            <p className="last-connected">
                                                Last Connected: {device.lastConnected}
                                            </p>
                                            <p className="last-connected">Session ID: {device.sessionId}</p>
                                        </div>
                                        <div className="device-actions">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => {
                                                    // Regenerate QR for this device
                                                    setPhoneNumber(device.phoneNumber);
                                                    setShowNewDeviceForm(true);
                                                }}
                                            >
                                                Reconnect
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDisconnectDevice(device.id)}
                                            >
                                                Disconnect
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-devices">
                                <div className="no-devices-content">
                                    <div className="no-devices-icon">📱</div>
                                    <h4>No WhatsApp devices connected</h4>
                                    <p>Add your first WhatsApp device to start sending messages</p>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleAddNewDevice}
                                    >
                                        Add Your First Device
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* New Device Form */}
                    {showNewDeviceForm && (
                        <div className="new-device-form">
                            <div className="form-header">
                                <h4>Add New WhatsApp Device</h4>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={handleCancelNewDevice}
                                >
                                    Cancel
                                </button>
                            </div>

                            <div className="dc-formtheme dc-userform">
                                <fieldset>
                                    <div className="form-group">
                                        <label htmlFor="whatsapp_phone_number">WhatsApp Phone Number</label>
                                        <input
                                            type="tel"
                                            id="whatsapp_phone_number"
                                            className="form-control"
                                            placeholder="Enter phone number (e.g., +1234567890)"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={generateQRCode}
                                            disabled={isGenerating}
                                        >
                                            {isGenerating ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                    Generating QR Code...
                                                </>
                                            ) : (
                                                'Generate QR Code'
                                            )}
                                        </button>
                                    </div>

                                    {qrCode && (
                                        <div className="form-group">
                                            <div className="qr-code-section">
                                                <h5>Your WhatsApp QR Code</h5>
                                                <div className="qr-code-container">
                                                    <div className="qr-code-placeholder">
                                                        <img src={qrCode} alt="Whatsapp QR Code" />
                                                    </div>
                                                </div>

                                                {/* Status Indicator */}
                                                <div className="status-indicator mt-3" style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    <div className={`status-badge ${qrCodeStatus}`} style={{
                                                        padding: '10px 20px',
                                                        borderRadius: '25px',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        textAlign: 'center',
                                                        border: '2px solid',
                                                        backgroundColor: qrCodeStatus === 'connected' ? '#d4edda' :
                                                            qrCodeStatus === 'waiting_for_scan' ? '#fff3cd' :
                                                                qrCodeStatus === 'disconnected' ? '#f8d7da' : '#d1ecf1',
                                                        borderColor: qrCodeStatus === 'connected' ? '#c3e6cb' :
                                                            qrCodeStatus === 'waiting_for_scan' ? '#ffeaa7' :
                                                                qrCodeStatus === 'disconnected' ? '#f5c6cb' : '#bee5eb',
                                                        color: qrCodeStatus === 'connected' ? '#155724' :
                                                            qrCodeStatus === 'waiting_for_scan' ? '#856404' :
                                                                qrCodeStatus === 'disconnected' ? '#721c24' : '#0c5460'
                                                    }}>
                                                        {qrCodeStatus === 'connected' && (
                                                            <span className="status-text">
                                                                ✅ WhatsApp Connected Successfully!
                                                            </span>
                                                        )}
                                                        {qrCodeStatus === 'waiting_for_scan' && (
                                                            <span className="status-text">
                                                                ⏳ Waiting for QR Code Scan...
                                                            </span>
                                                        )}
                                                        {qrCodeStatus === 'disconnected' && (
                                                            <span className="status-text">
                                                                ❌ WhatsApp Disconnected
                                                            </span>
                                                        )}
                                                        {!qrCodeStatus && (
                                                            <span className="status-text">
                                                                📱 Scan QR Code to Connect WhatsApp
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="form-group">
                                        <div className="scan-instructions">
                                            <h5>How to Scan QR Code</h5>
                                            <div className="instruction-content">
                                                <div className="instruction-gif">
                                                    <img src={require("../../../assets/images/scan-demo.gif")} alt="Whatsapp QR Code" />
                                                </div>
                                                <div className="instruction-steps">
                                                    <ol>
                                                        <li>Open WhatsApp on your phone</li>
                                                        <li>Tap the three dots menu (⋮) in the top right</li>
                                                        <li>Select "Linked Devices" or "WhatsApp Web"</li>
                                                        <li>Tap "Link a Device"</li>
                                                        <li>Point your camera at the QR code above</li>
                                                        <li>Wait for the connection to be established</li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                .connected-devices-list {
                    margin: 20px 0;
                }

                .devices-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 20px;
                    margin-top: 20px;
                }

                .device-card {
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    padding: 20px;
                    background: white;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    transition: all 0.3s ease;
                }

                .device-card:hover {
                    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
                    transform: translateY(-2px);
                }

                .device-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 15px;
                }

                .device-info h5 {
                    margin: 0 0 5px 0;
                    color: #333;
                    font-size: 16px;
                    font-weight: 600;
                }

                .device-info .phone-number {
                    margin: 0;
                    color: #666;
                    font-size: 14px;
                    font-family: monospace;
                }

                .device-status .status-badge {
                    padding: 4px 12px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 500;
                    white-space: nowrap;
                }

                .device-status .status-badge.connected {
                    background-color: #d4edda;
                    color: #155724;
                    border: 1px solid #c3e6cb;
                }

                .device-status .status-badge.disconnected {
                    background-color: #f8d7da;
                    color: #721c24;
                    border: 1px solid #f5c6cb;
                }

                .device-status .status-badge.waiting_for_scan {
                    background-color: #fff3cd;
                    color: #856404;
                    border: 1px solid #ffeaa7;
                }

                .device-details {
                    margin-bottom: 15px;
                }

                .device-details .last-connected {
                    margin: 0;
                    color: #888;
                    font-size: 13px;
                }

                .device-actions {
                    display: flex;
                    gap: 10px;
                    justify-content: flex-end;
                }

                .device-actions .btn {
                    padding: 6px 12px;
                    font-size: 12px;
                }

                .no-devices {
                    text-align: center;
                    padding: 60px 20px;
                    background: #f8f9fa;
                    border-radius: 12px;
                    border: 2px dashed #dee2e6;
                }

                .no-devices-content {
                    max-width: 400px;
                    margin: 0 auto;
                }

                .no-devices-icon {
                    font-size: 48px;
                    margin-bottom: 20px;
                }

                .no-devices-content h4 {
                    color: #495057;
                    margin-bottom: 10px;
                }

                .no-devices-content p {
                    color: #6c757d;
                    margin-bottom: 20px;
                }

                .new-device-form {
                    margin-top: 30px;
                    padding: 20px;
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    background-color: #f8f9fa;
                }

                .form-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #dee2e6;
                }

                .form-header h4 {
                    margin: 0;
                    color: #495057;
                }

                .qr-code-section {
                    margin-top: 20px;
                    padding: 20px;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    background-color: #f9f9f9;
                }

                .qr-code-container {
                    display: flex;
                    justify-content: center;
                    margin: 20px 0;
                }

                .qr-code-placeholder {
                    text-align: center;
                }

                .qr-code-box {
                    width: 200px;
                    height: 200px;
                    border: 2px solid #25D366;
                    border-radius: 8px;
                    background: white;
                    position: relative;
                    margin: 0 auto 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .qr-code-pattern {
                    position: relative;
                    width: 160px;
                    height: 160px;
                }

                .qr-corner {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    border: 3px solid #000;
                }

                .qr-corner.top-left {
                    top: 0;
                    left: 0;
                    border-right: none;
                    border-bottom: none;
                }

                .qr-corner.top-right {
                    top: 0;
                    right: 0;
                    border-left: none;
                    border-bottom: none;
                }

                .qr-corner.bottom-left {
                    bottom: 0;
                    left: 0;
                    border-right: none;
                    border-top: none;
                }

                .qr-dots {
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 2px;
                    margin-top: 25px;
                    margin-left: 25px;
                }

                .qr-dot {
                    width: 8px;
                    height: 8px;
                    background: transparent;
                    border-radius: 1px;
                }

                .qr-dot.filled {
                    background: #000;
                }

                .qr-link-text {
                    font-family: monospace;
                    color: #25D366;
                    font-weight: bold;
                    margin: 0;
                }

                .scan-instructions {
                    margin-top: 30px;
                    padding: 20px;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    background-color: #f0f8ff;
                }

                .instruction-content {
                    gap: 30px;
                    align-items: flex-start;
                }

                .instruction-gif {
                    flex-shrink: 0;
                }

                .gif-placeholder {
                    width: 150px;
                    height: 200px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .phone-mockup {
                    width: 80px;
                    height: 140px;
                    background: #333;
                    border-radius: 15px;
                    padding: 8px;
                    position: relative;
                }

                .phone-screen {
                    width: 100%;
                    height: 100%;
                    background: #f0f0f0;
                    border-radius: 8px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    overflow: hidden;
                }

                .whatsapp-icon {
                    position: absolute;
                    top: 20px;
                }

                .wa-icon {
                    font-size: 24px;
                }

                .scan-animation {
                    position: absolute;
                    bottom: 20px;
                    width: 50px;
                    height: 30px;
                    border: 2px solid #25D366;
                    border-radius: 4px;
                    overflow: hidden;
                }

                .scan-line {
                    width: 100%;
                    height: 2px;
                    background: #25D366;
                    animation: scan 2s infinite;
                }

                @keyframes scan {
                    0% { transform: translateY(-30px); }
                    100% { transform: translateY(30px); }
                }

                .instruction-steps {
                    flex: 1;
                }

                .instruction-steps ol {
                    padding-left: 20px;
                }

                .instruction-steps li {
                    margin-bottom: 8px;
                    line-height: 1.5;
                }

                .btn {
                    padding: 10px 20px;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.3s ease;
                }

                .btn-primary {
                    background-color: #007bff;
                    color: white;
                }

                .btn-primary:hover:not(:disabled) {
                    background-color: #0056b3;
                }

                .btn-success {
                    background-color: #28a745;
                    color: white;
                }

                .btn-success:hover {
                    background-color: #1e7e34;
                }

                .btn:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .form-control {
                    width: 100%;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    font-size: 14px;
                }

                .spinner-border-sm {
                    width: 1rem;
                    height: 1rem;
                }

                @media (max-width: 768px) {
                    .devices-grid {
                        grid-template-columns: 1fr;
                    }
                    
                    .device-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 10px;
                    }
                    
                    .device-actions {
                        justify-content: flex-start;
                        flex-wrap: wrap;
                    }
                    
                    .instruction-content {
                        flex-direction: column;
                        gap: 20px;
                    }
                    
                    .instruction-gif {
                        align-self: center;
                    }
                    
                    .form-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 10px;
                    }
                }
            `}</style>
        </div>
    );
};

export default WhatsappConfig;
